import { useContractorContext } from '@features/Contractor/ContractorContext'
import { HistoryLayout } from '@features/Contractor/History/HistoryLayout'
import { createFileRoute } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate'

export const Route = createFileRoute('/contractor/$contractorId/history')({
  component: ContractorHistoryRoute,
  staticData: {
    breadcrumb: t('contractor.profile.history.breadcrumb'),
  },
})

function ContractorHistoryRoute() {
  const { data } = useContractorContext()
  const { contractorId } = Route.useParams()

  return <HistoryLayout contractorId={contractorId} tenantId={data?.tenantId} />
}
